import { ReactNode } from "react";

import { Box, Text } from "@mantine/core";

interface InfoFieldProps {
  label: string;
  value: ReactNode;
  mb?: string;
}

const InfoField = ({ label, value, mb }: InfoFieldProps) => (
  <Box mb={mb}>
    <Text fz={13} c="dark" mb={4}>
      {label}
    </Text>
    <Text fz={15} fw={600}>
      {value}
    </Text>
  </Box>
);

export default InfoField;
